export default class ReportCategory {
  constructor(categoryId, categoryTitle, categoryIndex) {
    this.categoryId = categoryId;
    this.categoryTitle = categoryTitle;
    this.categoryIndex = categoryIndex;
    this.checklistResponses = [];
  }
}
